const wazeUrl = 'https://waze.com/ul?q=R.%20Alvorada,%201035%20-%20Vila%20Ol%C3%ADmpia,%20S%C3%A3o%20Paulo&navigate=yes';
const mapsUrl = 'https://www.google.com/maps/search/?api=1&query=R.+Alvorada,+1035+-+Vila+Ol%C3%ADmpia,+S%C3%A3o+Paulo';

export default function LocationSection() {
  const locationUrl = window.matchMedia('(max-width: 700px)').matches ? wazeUrl : mapsUrl;
  return (
    <section id="localizacao" className="location-reference">
      <img className="location-rose-left" src="/assets/rosas-localizacao.png" alt="" />
      <img className="location-rose-right" src="/assets/rosas-localizacao.png" alt="" />
      <div className="location-title"><i /><span>◆</span><h2>LOCALIZAÇÃO</h2><span>◆</span><i /></div>
      <div className="location-content">
        <a className="location-map" href={locationUrl} target="_blank" rel="noreferrer" aria-label="Abrir localização do Bisutti Zero Onze">
          <img src="/assets/bisutti-fachada.jpg" alt="Fachada do Bisutti Zero Onze" />
        </a>
        <div className="location-copy">
          <div className="location-venue"><i className="ri-map-pin-line"/><div><h3>BISUTTI ZERO ONZE</h3><p>R. Alvorada, 1035<br/>Vila Olímpia – São Paulo / SP</p></div></div>
          <a className="location-device-button location-waze-button" href={wazeUrl} target="_blank" rel="noreferrer"><i className="ri-navigation-fill"/><span>ABRIR NO WAZE</span><i className="ri-arrow-right-line"/></a>
          <a className="location-device-button location-maps-button" href={mapsUrl} target="_blank" rel="noreferrer"><i className="ri-map-2-line"/><span>ABRIR NO GOOGLE MAPS</span><i className="ri-arrow-right-line"/></a>
        </div>
      </div>
    </section>
  );
}
